<template>
  <div id="contact-page">
    <!-- site-navigation start -->
    <NavbarView />
    <!-- site-navigation end -->

    <!-- header begin -->
    <header class="page-head animated-banner">
      <div class="banner-container">
        <div class="glow"></div>

        <!-- Phone -->
        <div class="phone">
          <div class="phone-screen"></div>
        </div>

        <!-- Connection lines -->
        <div
          class="connection-line"
          style="left: 120px; top: 50px; width: 12%; transform: rotate(10deg)"
        ></div>
        <div
          class="connection-line"
          style="left: 120px; top: 80px; width: 18%; transform: rotate(-5deg)"
        ></div>
        <div
          class="connection-line"
          style="left: 120px; top: 100px; width: 15%; transform: rotate(-15deg)"
        ></div>
        <div
          class="connection-line"
          style="left: 20%; top: 60px; width: 24%; transform: rotate(5deg)"
        ></div>
        <div
          class="connection-line"
          style="left: 28%; top: 90px; width: 21%; transform: rotate(-8deg)"
        ></div>
        <div
          class="connection-line"
          style="left: 42%; top: 70px; width: 27%; transform: rotate(3deg)"
        ></div>
        <div
          class="connection-line"
          style="left: 54%; top: 50px; width: 24%; transform: rotate(-2deg)"
        ></div>
        <div
          class="connection-line"
          style="left: 66%; top: 90px; width: 21%; transform: rotate(7deg)"
        ></div>
        <div
          class="connection-line"
          style="left: 78%; top: 60px; width: 18%; transform: rotate(-5deg)"
        ></div>
        <div
          class="connection-line"
          style="left: 90%; top: 80px; width: 15%; transform: rotate(10deg)"
        ></div>

        <!-- Notification flow -->
        <div class="notification-flow">
          <!-- Notification icons -->
          <div class="notification" style="left: 8%; top: 40px">
            <i class="fa fa-envelope"></i>
          </div>
          <div class="notification" style="left: 15%; top: 70px">
            <i class="fa fa-comment"></i>
          </div>
          <div class="notification" style="left: 22%; top: 30px">
            <i class="fa fa-bell"></i>
          </div>
          <div class="notification" style="left: 29%; top: 90px">
            <i class="fa fa-map-marker"></i>
          </div>
          <div class="notification" style="left: 36%; top: 50px">
            <i class="fa fa-calendar"></i>
          </div>
          <div class="notification" style="left: 43%; top: 80px">
            <i class="fa fa-heart"></i>
          </div>
          <div class="notification" style="left: 50%; top: 40px">
            <i class="fa fa-clock-o"></i>
          </div>
          <div class="notification" style="left: 57%; top: 70px">
            <i class="fa fa-user"></i>
          </div>
          <div class="notification" style="left: 64%; top: 50px">
            <i class="fa fa-paperclip"></i>
          </div>
          <div class="notification" style="left: 71%; top: 90px">
            <i class="fa fa-image"></i>
          </div>
          <div class="notification" style="left: 78%; top: 40px">
            <i class="fa fa-file"></i>
          </div>
          <div class="notification" style="left: 85%; top: 70px">
            <i class="fa fa-share"></i>
          </div>
          <div class="notification" style="left: 92%; top: 50px">
            <i class="fa fa-lock"></i>
          </div>
          <div class="notification" style="left: 99%; top: 80px">
            <i class="fa fa-wifi"></i>
          </div>

          <!-- Message bubbles -->
          <div class="message-bubble" style="left: 18%; top: 50px"></div>
          <div class="message-bubble" style="left: 32%; top: 30px"></div>
          <div class="message-bubble" style="left: 46%; top: 40px"></div>
          <div class="message-bubble" style="left: 60%; top: 30px"></div>
          <div class="message-bubble" style="left: 74%; top: 60px"></div>
          <div class="message-bubble" style="left: 88%; top: 40px"></div>

          <!-- Particles -->
          <div class="particle" style="left: 12%; top: 60px"></div>
          <div class="particle" style="left: 24%; top: 40px"></div>
          <div class="particle" style="left: 36%; top: 70px"></div>
          <div class="particle" style="left: 48%; top: 50px"></div>
          <div class="particle" style="left: 60%; top: 80px"></div>
          <div class="particle" style="left: 72%; top: 40px"></div>
          <div class="particle" style="left: 84%; top: 60px"></div>
          <div class="particle" style="left: 96%; top: 70px"></div>
          <div class="particle" style="left: 16%; top: 50px"></div>
          <div class="particle" style="left: 28%; top: 90px"></div>
          <div class="particle" style="left: 40%; top: 30px"></div>
          <div class="particle" style="left: 52%; top: 60px"></div>
          <div class="particle" style="left: 64%; top: 40px"></div>
          <div class="particle" style="left: 76%; top: 70px"></div>
          <div class="particle" style="left: 88%; top: 50px"></div>
          <div class="particle" style="left: 92%; top: 80px"></div>
          <div class="particle" style="left: 20%; top: 40px"></div>
        </div>

        <!-- Overlay content -->
        <div class="header-wrapper">
          <div class="container">
            <div class="row">
              <div class="col-md-12">
                <!-- <ol class="breadcrumb">
                  <li><a href="index.html">Home</a></li>
                  <li class="active">Contact</li>
                </ol> -->
                <!-- end of /.breadcrumb -->
              </div>
            </div>
          </div>
          <!-- /.container -->
        </div>
        <!-- /.header-wrapper -->
      </div>
    </header>
    <!-- /.page-head (header end) -->

    <div class="main-content">
      <div class="container">
        <!-- contact-form -->
        <section class="contact-form">
          <!-- call for contact -->
          <div class="headline text-center">
            <div class="row">
              <div class="col-md-6 col-md-offset-3">
                <h2 class="section-title">Say Hello! Don't be shy</h2>
                <p class="section-sub-title">
                  If you have any questions or comments, or would just like to
                  say hello,
                  <br />please feel free to contact our friendly team
                </p>
                <!-- /section-sub-title -->
              </div>
            </div>
          </div>
          <!-- /.contact-speech -->

          <!-- Success/Error Messages -->
          <div
            v-if="showMessage"
            :class="[
              'alert',
              messageType === 'success' ? 'alert-success' : 'alert-danger',
            ]"
            style="margin-bottom: 20px; padding: 15px; border-radius: 4px"
          >
            {{ message }}
          </div>

          <form @submit.prevent="handleSubmit">
            <div class="row">
              <div class="col-md-4">
                <div class="form-group">
                  <input
                    v-model="formData.name"
                    name="name"
                    type="text"
                    class="form-control"
                    id="name"
                    required="required"
                    placeholder="Full Name"
                  />
                </div>

                <div class="form-group">
                  <input
                    v-model="formData.email"
                    name="email"
                    type="email"
                    class="form-control"
                    id="email"
                    required="required"
                    placeholder="Email Address"
                  />
                </div>

                <div class="form-group">
                  <input
                    v-model="formData.website"
                    name="website"
                    type="url"
                    class="form-control"
                    id="subject"
                    required="required"
                    placeholder="Your Website"
                  />
                </div>
              </div>

              <div class="col-md-8">
                <textarea
                  v-model="formData.message"
                  name="message"
                  type="text"
                  class="form-control"
                  id="message"
                  rows="8"
                  required="required"
                  placeholder="Type your message here"
                ></textarea>
              </div>
            </div>

            <button
              type="submit"
              id="submit"
              name="submit"
              class="btn btn-black"
              :disabled="isSubmitting"
            >
              {{ isSubmitting ? "Sending..." : "send message" }}
            </button>
          </form>
          <!-- form end -->
        </section>
        <!-- /.contact-form -->

        <!-- contact adresses section begin -->
        <section class="contact-address bg-white">
          <div class="row">
            <div class="col-md-4 col-xs-12">
              <div class="address-info">
                <div class="row">
                  <div class="col-md-3 col-xs-3">
                    <div
                      class="address-info-icon text-center center-block bg-light-gray"
                    >
                      <i class="fa fa-map-marker"></i>
                    </div>
                    <!-- /.address-info-icon -->
                  </div>

                  <div class="col-md-9 col-xs-9 address-info-desc">
                    <h3>Office Address</h3>
                    <p>
                      Vancouver, BC<br />
                      Canada
                    </p>
                  </div>
                  <!-- /.address-info-desc -->
                </div>
              </div>
              <!-- /.address-info -->
            </div>

            <div class="col-md-4 col-xs-12">
              <div class="address-info">
                <div class="row">
                  <div class="col-md-3 col-xs-3">
                    <div
                      class="address-info-icon text-center center-block bg-light-gray"
                    >
                      <i class="fa fa-phone"></i>
                    </div>
                    <!-- /.address-info-icon -->
                  </div>

                  <div class="col-md-9 col-xs-9 address-info-desc">
                    <h3>Phone</h3>
                    <p>
                      WhatsApp: (604) 999-9999
                      <br />
                      Business: (604) 333-3333
                    </p>
                  </div>
                  <!-- /.address-info-desc -->
                </div>
              </div>
              <!-- /.address-info -->
            </div>

            <div class="col-md-4 col-xs-12">
              <div class="address-info">
                <div class="row">
                  <div class="col-md-3 col-xs-3">
                    <div
                      class="address-info-icon text-center center-block bg-light-gray"
                    >
                      <i class="fa fa-envelope-o"></i>
                    </div>
                    <!-- /.address-info-icon -->
                  </div>

                  <div class="col-md-9 col-xs-9 address-info-desc">
                    <h3>Email</h3>
                    <p>
                      contact@digiprod.ca
                      <br />
                      www.digiprod.ca
                    </p>
                  </div>
                  <!-- /.address-info-desc -->
                </div>
              </div>
              <!-- /.address-info -->
            </div>
          </div>
        </section>
        <!-- /.contact-address -->
      </div>
      <!-- container -->
    </div>
    <!-- main-content end -->

    <FooterView />
  </div>
</template>

<script>
import { ref, onMounted } from "vue";
import { useReCaptcha } from "vue-recaptcha-v3";
import emailjs from "@emailjs/browser";
import NavbarView from "@/components/Navbar.vue";
import FooterView from "@/components/Footer.vue";

export default {
  name: "ContactView",
  components: {
    NavbarView,
    FooterView,
  },
  setup() {
    const { executeRecaptcha, recaptchaLoaded } = useReCaptcha();

    const formData = ref({
      name: "",
      email: "",
      website: "",
      message: "",
    });

    const isSubmitting = ref(false);
    const showMessage = ref(false);
    const message = ref("");
    const messageType = ref("");

    // EmailJS Configuration (same as Portuguese version)
    const EMAILJS_SERVICE_ID = "service_ui5zmnj";
    const EMAILJS_TEMPLATE_ID = "template_neizbuo";
    const EMAILJS_PUBLIC_KEY = "1BXZs4pDWpcgrN5rx";
    const RECIPIENT_EMAIL = "contact@digiprod.ca";

    onMounted(async () => {
      await recaptchaLoaded();
      // Initialize EmailJS
      emailjs.init(EMAILJS_PUBLIC_KEY);
    });

    const showSuccessMessage = (msg) => {
      message.value = msg;
      messageType.value = "success";
      showMessage.value = true;
      setTimeout(() => {
        showMessage.value = false;
      }, 5000);
    };

    const showErrorMessage = (msg) => {
      message.value = msg;
      messageType.value = "error";
      showMessage.value = true;
      setTimeout(() => {
        showMessage.value = false;
      }, 5000);
    };

    const handleSubmit = async () => {
      if (isSubmitting.value) return;

      try {
        isSubmitting.value = true;
        showMessage.value = false;

        // Execute reCAPTCHA
        const recaptchaToken = await executeRecaptcha("submit");

        if (!recaptchaToken) {
          showErrorMessage("Error verifying reCAPTCHA. Please try again.");
          isSubmitting.value = false;
          return;
        }

        // Prepare email template parameters
        const templateParams = {
          from_name: formData.value.name,
          from_email: formData.value.email,
          website: formData.value.website,
          message: formData.value.message,
          to_email: RECIPIENT_EMAIL,
          recaptcha_token: recaptchaToken,
        };

        // Send email via EmailJS
        await emailjs.send(
          EMAILJS_SERVICE_ID,
          EMAILJS_TEMPLATE_ID,
          templateParams
        );

        // Reset form
        formData.value = {
          name: "",
          email: "",
          website: "",
          message: "",
        };

        showSuccessMessage(
          "Message sent successfully! We'll get back to you soon."
        );
      } catch (error) {
        console.error("Error sending email:", error);
        showErrorMessage(
          "Error sending message. Please try again or contact us directly by email."
        );
      } finally {
        isSubmitting.value = false;
      }
    };

    return {
      formData,
      isSubmitting,
      showMessage,
      message,
      messageType,
      handleSubmit,
    };
  },
};
</script>

<style scoped>
/* Animated Banner Styles */
.animated-banner {
  position: relative;
  overflow: hidden;
  height: 157px;
}

.banner-container {
  width: 100%;
  height: 157px;
  position: relative;
  background: linear-gradient(120deg, #6a11cb 0%, #2575fc 100%);
  overflow: hidden;
}

.phone {
  position: absolute;
  left: 40px;
  top: 30px;
  width: 60px;
  height: 110px;
  background: linear-gradient(145deg, #8a3cff 0%, #5e3bff 100%);
  border-radius: 12px;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.2);
  transform: perspective(500px) rotateY(15deg) rotateX(5deg);
  z-index: 10;
}

.phone-screen {
  position: absolute;
  left: 4px;
  top: 4px;
  width: 52px;
  height: 102px;
  background: linear-gradient(145deg, #6a3bff 0%, #3b26c5 100%);
  border-radius: 8px;
}

.notification-flow {
  position: absolute;
  left: 120px;
  top: 0;
  width: calc(100% - 120px);
  height: 100%;
  display: flex;
  align-items: center;
}

.notification {
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.2);
  color: white;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  animation: float 3s infinite ease-in-out;
}

.notification i {
  font-size: 16px;
}

.message-bubble {
  position: absolute;
  width: 60px;
  height: 30px;
  background: rgba(255, 255, 255, 0.25);
  border-radius: 15px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.connection-line {
  position: absolute;
  height: 2px;
  background: rgba(255, 255, 255, 0.4);
  transform-origin: left center;
  z-index: 1;
}

.glow {
  position: absolute;
  width: 100%;
  height: 100%;
  background: radial-gradient(
    circle at 30% 50%,
    rgba(106, 17, 203, 0.4) 0%,
    rgba(37, 117, 252, 0) 70%
  );
  z-index: 0;
}

.particle {
  position: absolute;
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.6);
  box-shadow: 0 0 8px 1px rgba(255, 255, 255, 0.3);
}

@keyframes float {
  0%,
  100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-8px);
  }
}

/* Header wrapper overlay */
.header-wrapper {
  background-color: rgba(0, 0, 0, 0.45);
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  padding: 65px 0px;
  z-index: 15;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .banner-container {
    height: 157px;
  }

  .phone {
    width: 40px;
    height: 80px;
    left: 20px;
    top: 35px;
  }

  .phone-screen {
    width: 32px;
    height: 72px;
    left: 4px;
    top: 4px;
  }

  .notification-flow {
    left: 80px;
    width: calc(100% - 80px);
  }

  .notification {
    width: 24px;
    height: 24px;
  }

  .notification i {
    font-size: 12px;
  }

  .message-bubble {
    width: 40px;
    height: 20px;
  }

  .connection-line {
    height: 1px;
  }

  .particle {
    width: 3px;
    height: 3px;
  }

  /* Hide some elements on mobile to avoid overcrowding */
  .notification:nth-child(n + 8),
  .message-bubble:nth-child(n + 4),
  .particle:nth-child(n + 6),
  .connection-line:nth-child(n + 6) {
    display: none;
  }
}

@media (max-width: 480px) {
  .banner-container {
    height: 157px;
  }

  .notification:nth-child(n + 5),
  .message-bubble:nth-child(n + 3),
  .particle:nth-child(n + 4),
  .connection-line:nth-child(n + 4) {
    display: none;
  }
}
</style>
